import { PLANNING_STATES } from "../../../classes/enums/PlanningStateEnum";
import ImageViewer from "../../../components/imageViewer/ImageViewer";
import RemoteViewer from "../../../components/remoteViewer/RemoteViewer";
import measurementToolManager from "../../../services/MeasurementToolService";
import "./DxViewer.css";

// Normalize view name to display settings key
const getDisplaySettingsViewType = viewName => {
  if (!viewName) return null;
  const lower = viewName.toLowerCase();
  if (lower.includes("lateral") || lower.includes("sagittal")) return "lateral";
  if (lower.includes("front") || lower.includes("coronal")) return "frontal";
  if (lower.includes("axial")) return "axial";
  return null;
};

const getDataFusionProjectionLabel = viewName => {
  if (!viewName) return null;
  const lower = viewName.toLowerCase();
  if (lower.includes("lateral") || lower.includes("sagittal")) {
    return "CT - supine sagittal projection";
  }
  if (lower.includes("front") || lower.includes("coronal")) {
    return "CT - supine coronal projection";
  }
  return null;
};

const DxViewer = ({
  views,
  handleImageClose,
  renderClient,
  isDataFusionActive,
  changeCtFusionSlice,
  addCustomMeasurement,
  isViewClosing,
  planId,
}) => {
  return (
    <div className="Check-dx-grid">
      {views.map(view => (
        <ImageViewer
          key={`image-container-${view.key}`}
          className={
            isViewClosing(view.viewData.viewId, view.instance._id, null, "DX")
              ? "Check-closing"
              : ""
          }
          viewData={view.viewData}
          instance={view.instance}
          onClose={() =>
            handleImageClose(
              view.instance._id,
              view.viewData.viewId,
              null,
              "DX"
            )
          }
          onContentLoad={() => {}}
          onBrightnessClick={() => {}}
          onChangeSlice={changeCtFusionSlice}
          isDataFusionActive={isDataFusionActive}
          step={PLANNING_STATES.CHECK}
          viewType={view.viewName}
          viewId={view.viewData.viewId}
          remoteRenderClient={renderClient}
          planId={planId || PLANNING_STATES.CHECK}
          instanceId={view.instance?._id}
          displaySettingsViewType={getDisplaySettingsViewType(view.viewName)}
          persistedDisplaySettings={
            view.instance?.display_settings?.[
              getDisplaySettingsViewType(view.viewName)
            ]
          }
        >
          <RemoteViewer
            remoteRenderClient={renderClient}
            viewData={view.viewData}
            sliderWidth="80%"
            watermarkText={isDataFusionActive ? "Align the sacrum on both X-Rays and projected CT to assess spine mobility" : null}
            secondaryWatermarkText={isDataFusionActive ? getDataFusionProjectionLabel(view.viewName) : null}
            onAddMeasurement={mousePosition => {
              const executionCallback = measurementToolManager.executeOnView(
                view.viewData,
                addCustomMeasurement
              );
              if (executionCallback) {
                executionCallback(mousePosition);
              }
            }}
          />
        </ImageViewer>
      ))}
    </div>
  );
};

export default DxViewer;
